import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'Login', component: () => import('@/views/LoginView.vue'), meta: { public: true } },
    {
      path: '/',
      component: () => import('@/layouts/AppLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        { path: '', redirect: '/dashboard' },
        { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/DashboardView.vue') },
        { path: 'employees', name: 'Employees', component: () => import('@/views/EmployeesView.vue') },
        { path: 'employees/:pseudoId', name: 'EmployeeDetail', component: () => import('@/views/EmployeeDetailView.vue') },
        { path: 'opportunities', name: 'Opportunities', component: () => import('@/views/OpportunitiesView.vue') },
        { path: 'forms', name: 'Forms', component: () => import('@/views/FormsView.vue') },
        { path: 'analytics', name: 'Analytics', component: () => import('@/views/AnalyticsView.vue') },
        { path: 'catalogues', name: 'Catalogues', component: () => import('@/views/CataloguesView.vue') },
        { path: 'mentors', name: 'Mentors', component: () => import('@/views/MentorsView.vue') },
        { path: 'audit', name: 'AuditLog', component: () => import('@/views/AuditLogView.vue') },
        { path: 'notifications', name: 'Notifications', component: () => import('@/views/NotificationsView.vue') },
        { path: 'skills-validation', name: 'SkillsValidation', component: () => import('@/views/SkillsValidationView.vue') },
        { path: 'dev-plans', name: 'DevPlans', component: () => import('@/views/DevPlansView.vue') },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (to.meta.public) return true
  if (!auth.isAuthenticated) {
    await auth.initSession()
    if (!auth.isAuthenticated) return { name: 'Login', query: { redirect: to.fullPath } }
  }
  return true
})
